export class MiscModelGroup {
	public Group: string | null;
	public GroupForDisplay: string | null;
}
